import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface Row {
  label?: string
  available_hours: number | null
  booked_hours: number | null
  idle_hours: number | null
  utilization: number | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UtilizationWidget',
  props: {
    data: null,
    grouped: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: Row[]
  grouped?: boolean
}



const rows = computed<Row[]>(() => Array.isArray(props.data) ? props.data : [])
const single = computed<Row | null>(() => (rows.value.length > 0 ? rows.value[0] : null))

// 270° ring (gap at the bottom). C = circumference; the visible track is 75% of it.
const R = 72
const C = 2 * Math.PI * R
const ARC = 0.75
const trackDash = `${(C * ARC).toFixed(2)} ${C.toFixed(2)}`
const progDash = computed(() => {
  const u = single.value ? Math.max(0, Math.min(100, Number(single.value.utilization) || 0)) : 0
  return `${(C * ARC * (u / 100)).toFixed(2)} ${C.toFixed(2)}`
})

function fmt(v: number | null | undefined): string {
  if (v === null || v === undefined || isNaN(Number(v))) return '–'
  return Number(v).toFixed(1)
}
function fillPct(row: Row): number {
  const avail = Number(row.available_hours)
  const booked = Number(row.booked_hours)
  if (!avail || avail <= 0 || isNaN(booked)) return 0
  return Math.max(0, Math.min(100, (booked / avail) * 100))
}
function barTitle(row: Row): string {
  return `${fmt(row.booked_hours)}h booked of ${fmt(row.available_hours)}h staffed`
}

return { __sfc: true,props, rows, single, R, C, ARC, trackDash, progDash, fmt, fillPct, barTitle }
}

})